import React, { FC, useCallback } from 'react';

import { useIntl } from 'react-intl';

import { ICartEntryType } from 'state/loyalty/in-restaurant-redemption';

import RewardRedemptionIncrementor from './reward-redemption-incrementor';
import { Badge, BadgeWrapper, Container } from './styled';
import { BadgeAndIncrementorProps } from './types';

enum IncrementorActions {
  Increment = 'increment',
  Decrement = 'decrement',
}

const BadgeAndIncrementor: FC<React.PropsWithChildren<BadgeAndIncrementorProps>> = ({
  cartEntry,
  handleUpdateEntry,
}) => {
  const { formatMessage } = useIntl();
  const isDetailsReward = cartEntry.type === ICartEntryType.REWARD;

  const handleChangeQuantity = useCallback(
    (value: number) => {
      handleUpdateEntry(
        cartEntry,
        { quantity: value },
        value < cartEntry.quantity ? IncrementorActions.Decrement : IncrementorActions.Increment
      );
    },
    [handleUpdateEntry, cartEntry]
  );

  return (
    <Container>
      <BadgeWrapper testID="badge" $orange={isDetailsReward}>
        <Badge>{formatMessage({ id: isDetailsReward ? 'reward' : 'offer' })}</Badge>
      </BadgeWrapper>

      {cartEntry.type === ICartEntryType.REWARD && (
        <RewardRedemptionIncrementor
          quantity={cartEntry.quantity}
          details={cartEntry.details}
          onChange={handleChangeQuantity}
        />
      )}
    </Container>
  );
};

export default BadgeAndIncrementor;
